<template>
  <div class="row justify-content-center email-validation-form">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0" style="border-radius:10px;">
        <div
          class="card-body px-lg-5 py-lg-5 shadow"
          style="border:2px solid #d0d0d0;border-radius:10px;"
        >
          <div class="text-center">
            <h3 class>Nuevo inicio de sesión</h3>
            <div class="col-md-12 text-center">
              <div
                style="margin-top:60px"
              >Te enviamos un email a la casilla de correo registrada en tu cuenta, para que verifiques tu actividad.</div>
              <div
                style="margin-top:20px"
              >Ingresá a tu correo y presioná el botón "SI, SOY YO" para continuar usando este dispositivo.</div>
            </div>
            <div class="row" style="margin-top:20px">
              <div class="col-md-12 text-center">
                <span>Tiempo restante: {{segundosAMinutos()}}</span>
              </div>
            </div>
            <div class="row text-center" style="margin-top: 20px">
              <div class="col-md-12">
                <b-button
                  class="btn btn-lg btn-danger"
                  @click="SendAssociateDeviceEmail()"
                  :disabled="model.enableSendMail == false"
                >Reenviar mail</b-button>
              </div>
            </div>
            <div class="row text-center" style="margin-top: 10px">
              <div class="col-md-12">
                <b-button class="btn btn-lg btn-danger" @click="logout">Volver</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.label-link {
  cursor: pointer;
}
</style>
<script>
import axiosHelpers from "@/helpers/axiosHelpers";

export default {
  name: "NuevoInicioSesion",
  data() {
    return {
      model: {
        sengundosEnMinuto: 60,
        totalTime: 0,
        countDown: 5,
        continue: true,
        enableSendMail: false
      }
    };
  },
  methods: {
    segundosAMinutos() {
      var context = this;
      var minutos = Math.floor(
        context.model.totalTime / context.model.sengundosEnMinuto
      );
      var segundosRestantes =
        context.model.totalTime % context.model.sengundosEnMinuto;
      return (
        minutos + ":" + (segundosRestantes < 10 ? "0" : "") + segundosRestantes
      );
    },
    logout() {
      let context = this;
      context.model.continue = false;
      axiosHelpers.axiosPost("Account/InitialLogout", {}, this, function(data) {
        if (data.ResponseVM != null) {
          context.$store.dispatch("logout").then(() => {
            context.$router.push("login");
          });
        }
      });
    },
    countDownTimer() {
      let context = this;
      if (context.model.totalTime > 0 && context.model.continue) {
        if (context.model.countDown > 0) {
          setTimeout(() => {
            context.model.totalTime -= 1;
            context.model.countDown -= 1;
            context.countDownTimer();
          }, 1000);
        } else {
          axiosHelpers.axiosGet(
            "Account/ValidateAssociateAccountDevice",
            {},
            context,
            function(data) {
              if (data.ResponseVM.Success) {
                context.model.continue = false;

                context.$store.commit('setNewDevice', false);

                context.$router.push("dashboard");
              }
              if (data.ResponseVM.Blocked) {
                context.logout();
              } else {
                context.model.countDown = 5;
                context.countDownTimer();
              }
            }
          );
        }
      } else {
      }
    },
    SendAssociateDeviceEmail() {
      let context = this;

      axiosHelpers.axiosPostWithOutSecurityValidations(
        "Account/SendAssociateDeviceEmail",
        {},
        context,
        function(data) {
          if (data.ResponseVM.Success) {
            context.model.enableSendMail = false;

            context.model.totalTime =
              context.$store.getters
                .CODE_EXPIRATION_TIME_ASOCIATE_DEVICE_VALIDATION *
              context.model.sengundosEnMinuto;
            context.countDownTimer();
          } else if (data.ResponseVM.BlockAccount) {
            context.logout();
          }
        }
      );
    }
  },
  watch: {
    "model.totalTime": function(newVal) {
      if (newVal == 0) {
        this.model.enableSendMail = true;
      }
    }
  },
  beforeMount: function() {
    var context = this;
    context.SendAssociateDeviceEmail();
  }
};
</script>
